<div class="flex flex-col gap-4">
  <header class="flex flex-row justify-between items-center pb-4">
    <h1 class="text-3xl font-bold text-[color:var(--text-color)]">{{ 'financePages.eventRevenueTitle' | translate }}</h1>
    <div class="flex flex-row items-center gap-4">

      <bo-date-range-picker [startDate]="dateRange().startDate" [endDate]="dateRange().endDate"
        (dateRangeChange)="onDateRangeChange($event)" />
      <button pButton pRipple type="button" [label]="'financePages.reset' | translate" icon="pi pi-refresh"
        class="p-button-outlined event-revenue-reset-btn" (click)="onReset()"></button>
    </div>
  </header>

  <div
    class="kpi-cards-grid grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] ml-[1px] gap-6 md:grid-cols-3 md:gap-4">
    @for (card of kpiCards(); track card.title) {
    <bo-kpi-card [data]="card" />
    }
  </div>

  <bo-revenue-chart [data]="chartData()" />

  <bo-ticket-metrics-by-event [data]="ticketMetrics()" [startDate]="getStartDateISO()" [endDate]="getEndDateISO()" />
</div>